<template>
  <div
    class="table-wrapper"
    v-on:scroll="scrollFunction($event)"
    v-if="leaderboardData"
  >
    <CustomTable
      custom-class="leaderboard-table"
      :newDesign="true"
      :class="{
        'scroll-table': scrollLeftOver185,
        'leaderboard-table-club': scope === 'ORGANIZATION',
      }"
      v-if="
        !noData && (leaderboardData.currentTeam || leaderboardData.fixedRow)
      "
    >
      <template slot="theader">
        <TableRow>
          <TableCell>
            <span class="order-link-wrapper">
              {{ $t("LEADERBOARD.rank") }}
            </span>
          </TableCell>

          <TableCell v-if="scope === 'UNIVERSE'">
            <span class="order-link-wrapper">
              {{ $t("LEADERBOARD.club") }}
            </span>
          </TableCell>

          <TableCell
            :class="{
              'fixed-column-leaderboard team-header-cell': scrollLeftOver185,
            }"
          >
            <span class="order-link-wrapper">
              {{ teamIndividual === "team" ? $t("LEADERBOARD.team") : "Name" }}
            </span>
          </TableCell>

          <TableCell>
            <span class="order-link-wrapper">
              {{
                timeFrame === "LAST_7_DAYS"
                  ? $t("LEADERBOARD.totalLast7days")
                  : $t("LEADERBOARD.totalContest")
              }}
            </span>
          </TableCell>

          <TableCell
            class="pre-line"
            v-for="(day, index7) in last7Days"
            :key="index7"
          >
            {{ day }}
          </TableCell>
        </TableRow>
        <TableRow class="active">
          <TableCell>
            {{
              leaderboardData.currentTeam
                ? leaderboardData.currentTeam.rank
                : leaderboardData.fixedRow.rank
            }}
          </TableCell>

          <template v-if="scope === 'UNIVERSE' && leaderboardData.currentTeam">
            <TableCell id="currentTeam">
              {{ leaderboardData.currentTeam.organization.slice(0, 14) }}
              <b-tooltip
                target="currentTeam"
                triggers="hover"
                :custom-class="'org-hover'"
              >
                {{ leaderboardData.currentTeam.organization }}
              </b-tooltip>
            </TableCell>
          </template>

          <template v-if="scope === 'UNIVERSE' && leaderboardData.fixedRow">
            <TableCell id="currentTeam">
              {{
                leaderboardData.fixedRow.organization === null
                  ? "-"
                  : leaderboardData.fixedRow.organization.slice(0, 14)
              }}
              <b-tooltip
                v-if="leaderboardData.fixedRow.organization"
                target="currentTeam"
                triggers="hover"
                :custom-class="'org-hover'"
              >
                {{ leaderboardData.fixedRow.organization }}
              </b-tooltip>
            </TableCell>
          </template>

          <TableCell
            :class="{
              'fixed-column-leaderboard current-cell': scrollLeftOver185,
            }"
          >
            <span class="team-name">{{
              leaderboardData.currentTeam
                ? leaderboardData.currentTeam.name
                : `${
                    leaderboardData.fixedRow.name.split(" ")[0]
                  } ${leaderboardData.fixedRow.name.split(" ")[1].slice(0, 1)}.`
            }}</span>
          </TableCell>

          <TableCell>
            {{
              leaderboardData.currentTeam
                ? parseFloat(
                    leaderboardData.currentTeam.aggregatedData
                  ).toLocaleString("us")
                : parseFloat(
                    leaderboardData.fixedRow.aggregatedData
                  ).toLocaleString("us")
            }}
            <span
              v-if="timeFrame === 'LAST_7_DAYS' && leaderboardData.currentTeam"
              :class="
                leaderboardData.currentTeam.change.charAt(0) === '+'
                  ? 'positive'
                  : leaderboardData.currentTeam.change.charAt(0) === '-'
                  ? 'negative'
                  : ''
              "
              >({{ leaderboardData.currentTeam.change }})</span
            >
            <span
              v-if="timeFrame === 'LAST_7_DAYS' && leaderboardData.fixedRow"
              :class="
                leaderboardData.fixedRow.change.charAt(0) === '+'
                  ? 'positive'
                  : leaderboardData.fixedRow.change.charAt(0) === '-'
                  ? 'negative'
                  : ''
              "
              >({{ leaderboardData.fixedRow.change }})</span
            >
          </TableCell>

          <template
            v-if="leaderboardData.currentTeam && timeFrame === 'LAST_7_DAYS'"
          >
            <TableCell
              v-for="(day7days,
              i) in leaderboardData.currentTeam.days.slice().reverse()"
              :key="i"
            >
              {{ day7days }}
            </TableCell>
          </template>

          <template
            v-if="leaderboardData.currentTeam && timeFrame !== 'LAST_7_DAYS'"
          >
            <TableCell
              v-for="(day7days, i) in leaderboardData.currentTeam.days"
              :key="i"
            >
              {{ day7days }}
            </TableCell>
          </template>

          <template
            v-if="leaderboardData.fixedRow && timeFrame === 'LAST_7_DAYS'"
          >
            <TableCell
              v-for="(day7days,
              i) in leaderboardData.fixedRow.days.slice().reverse()"
              :key="i"
            >
              {{ day7days }}
            </TableCell>
          </template>

          <template
            v-if="leaderboardData.fixedRow && timeFrame !== 'LAST_7_DAYS'"
          >
            <TableCell
              v-for="(day7days, i) in leaderboardData.fixedRow.days"
              :key="i"
            >
              {{ day7days }}
            </TableCell>
          </template>

          <!-- <template v-if="timeFrame === 'CURRENT_WEEK'">
              <TableCell  v-for="(day, j) in currentTeamWeekValues[0]" :key="j">
                {{ day }}
              </TableCell>
            </template> -->
        </TableRow>
      </template>

      <template slot="tbody">
        <TableRow v-for="item in leaderboardData.rowList" :key="item.teamId">
          <TableCell>
            {{ item.rank }}
          </TableCell>

          <TableCell
            class="text-overflow p-1"
            v-if="scope === 'UNIVERSE'"
            :id="`org_${item.name}`"
          >
            {{ item.organization }}
            <b-tooltip
              :target="`org_${item.name}`"
              triggers="hover"
              :custom-class="'org-hover'"
            >
              {{ item.organization }}
            </b-tooltip>
          </TableCell>

          <TableCell
            :class="{ 'fixed-column-leaderboard team-cell': scrollLeftOver185 }"
          >
            <span class="team-name">{{
              leaderboardData.currentTeam
                ? item.name
                : `${item.name.split(" ")[0]} ${item.name
                    .split(" ")[1]
                    .slice(0, 1)}.`
            }}</span>
          </TableCell>

          <TableCell>
            {{ parseFloat(item.aggregatedData).toLocaleString("us") }}
          </TableCell>

          <template v-if="timeFrame === 'LAST_7_DAYS'">
            <TableCell
              v-for="(day, index2) in item.days.slice().reverse()"
              :key="index2"
            >
              {{ day }}
            </TableCell>
          </template>

          <template v-if="timeFrame !== 'LAST_7_DAYS'">
            <TableCell v-for="(day, index3) in item.days" :key="index3">
              {{ day }}
            </TableCell>
          </template>
        </TableRow>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { CustomTable, TableRow, TableCell } from "@/components/common/table"
import moment from "moment"
import i18n from "../../i18n"
import { MONTH_DAY_FORMAT } from "@/constants/DateConstants"
import { mapActions } from "vuex"
import { DESTROY_LEADERBOARD_DATA } from "@/store/action.types"

export default {
  name: "LeaderboardTable",
  props: {
    leaderboardData: Object,
    scope: String,
    timeFrame: String,
    teamIndividual: String,
    noData: Boolean,
  },
  data() {
    return {
      scrollLeftOver185: false,
      firstRow: null,
    }
  },
  computed: {
    last7Days() {
      const daysArr = []
      if (this.timeFrame === "LAST_7_DAYS") {
        for (let i = 6; i >= 0; i--) {
          const startdate = moment()
          startdate = startdate.subtract(i, "days")
          startdate = startdate
            .locale(i18n.locale)
            .format("ddd [\n]" + MONTH_DAY_FORMAT)
          daysArr.push(startdate)
        }
        daysArr.reverse()
      } else if (this.timeFrame === "CURRENT_WEEK") {
        const startdate = moment()
        const weekStart = startdate.clone().startOf("isoWeek")
        // const weekEnd = startdate.clone().endOf('isoWeek');
        for (let i = 0; i <= 6; i++) {
          daysArr.push(
            moment(weekStart)
              .add(i, "days")
              .locale(i18n.locale)
              .format("ddd [\n]" + MONTH_DAY_FORMAT)
          )
        }
      } else {
        const startdate = moment()
        const weekStart = startdate.subtract(1, "weeks").startOf("isoWeek")
        // const weekEnd = startdate.clone().endOf('isoWeek');
        for (let i = 0; i <= 6; i++) {
          daysArr.push(
            moment(weekStart)
              .add(i, "days")
              .locale(i18n.locale)
              .format("ddd [\n]" + MONTH_DAY_FORMAT)
          )
        }
      }
      return daysArr
    },

    // currentWeekValues() {
    //   let currentWeekValuesArr = [];
    //    if (this.timeFrame === 'CURRENT_WEEK') {
    //       var teams = this.leaderboardData.rowList;
    //     for(var i = 0; i < teams.length; i++) {
    //       var result = [];
    //       var todayIndex = moment().day();
    //       for (var j = todayIndex - 1; j >=0; j--) {
    //         result.push(teams[i].days[j])
    //       }
    //       var rest = new Array(7 - todayIndex).fill(0)
    //       result = result.concat(rest);

    //       currentWeekValuesArr.push(result)

    //     }
    //    }
    //    return currentWeekValuesArr
    // },

    // currentTeamWeekValues() {
    //   let currentTeamWeekValuesArr = [];
    //    if (this.timeFrame === 'CURRENT_WEEK') {
    //     var currentTeam = this.leaderboardData.currentTeam ? this.leaderboardData.currentTeam : this.leaderboardData.fixedRow;
    //     var result = [];
    //     var todayIndex = moment().day();
    //     for (var i = todayIndex - 1; i >=0; i--) {
    //       result.push(currentTeam.days[i])
    //     }
    //     var rest = new Array(7 - todayIndex).fill(0)
    //     result = result.concat(rest);

    //     currentTeamWeekValuesArr.push(result)
    //   }
    //    return currentTeamWeekValuesArr
    // }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
    this.destroyLeaderboardData()
  },
  methods: {
    ...mapActions({
      destroyLeaderboardData: DESTROY_LEADERBOARD_DATA,
    }),

    scrollFunction(event) {
      event.target.scrollLeft > 185
        ? (this.scrollLeftOver185 = true)
        : (this.scrollLeftOver185 = false)
    },

    handleScroll(event) {
      var windowScrollTop = document.documentElement.scrollTop
      var tableWrapper = document.querySelector(".leaderboard-table")
      if (tableWrapper) {
        var mainHeader = document.querySelector(".main-header-table")

        if (tableWrapper && windowScrollTop > tableWrapper.offsetTop + 40) {
          mainHeader.classList.add("sticky-header-table")

          if (window.innerWidth < 992) {
            mainHeader.style.top =
              windowScrollTop - tableWrapper.offsetTop - 32 + "px"
          } else if (window.innerWidth < 1200) {
            mainHeader.style.top =
              windowScrollTop - tableWrapper.offsetTop - 30 + "px"
          } else {
            mainHeader.style.top =
              windowScrollTop - tableWrapper.offsetTop + "px"
          }
        } else {
          if (mainHeader) {
            mainHeader.classList.remove("sticky-header-table")
          }
        }
      }
    },
  },
  watch: {
    leaderboardData(newValue, oldValue) {
      if (newValue.currentTeam) {
        this.firstRow = newValue.currentTeam
      } else {
        this.firstRow = newValue.fixedRow
      }
    },
  },
  components: {
    CustomTable,
    TableRow,
    TableCell,
  },
}
</script>

<style lang="scss">
.table-wrapper {
  overflow: auto;
}

.leaderboard-table {
  table-layout: fixed;
  min-width: 990px;
  text-align: center;

  .sticky-header-table {
    position: sticky;
    z-index: 11;
    transition: top 0.001s;
    .fixed-column-leaderboard {
      position: fixed !important;
      left: 45px;
      top: 134px;
    }

    .team-header-cell {
      top: 80px;
    }
  }

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .table-cell {
    &:first-child {
      width: 5%;
    }

    &:nth-child(2) {
      width: 9%;
      text-align: left;
    }

    &:nth-child(3) {
      width: 10%;
      text-align: left;
    }

    &:nth-child(n + 4) {
      width: 5%;
    }
  }
  .positive {
    color: green;
  }
  .negative {
    color: #c93434;
  }
  .fixed-column-leaderboard {
    position: absolute;
    left: 45px;
    width: 20% !important;
    border-bottom: 1px solid #222224;
    z-index: 10;
    text-align: center !important;
    .team-name {
      position: absolute;
      width: 95%;
      top: 50%;
      left: 0;
      transform: translate(0, -50%);
    }
  }

  .current-cell {
    background-color: #454546;
    padding-top: 20px !important;
  }

  .team-cell {
    background-color: #090909;
    padding-top: 20px !important;
  }

  .team-header-cell {
    background-color: #090909;
    height: 64px;
    z-index: 100;
    border-bottom: none;
  }

  .pre-line {
    white-space: pre-line;
    transform: translate(0, -9px);
  }
}
.leaderboard-table-club {
  .table-cell {
    &:nth-child(2) {
      width: 20% !important;
      text-align: center;
    }

    &:nth-child(3) {
      width: 5%;
      text-align: center;
    }

    &:nth-child(n + 4) {
      width: 10%;
    }
  }
}

.scroll-table {
  .table-cell {
    &:nth-child(n + 4) {
      width: 8%;
    }
  }
}

@media screen and (max-width: 992px) {
  .leaderboard-table {
    .sticky-header-table {
      .fixed-column-leaderboard {
        left: 120px;
        &.current-cell {
          top: 133px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .fixed-column-leaderboard {
    left: 25px !important;
  }
  .leaderboard-table {
    .sticky-header-table {
      .fixed-column-leaderboard {
        &.current-cell {
          top: 134px;
        }
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .fixed-column-leaderboard {
    padding-left: 5px !important;
  }
}

@media screen and (max-width: 480px) {
  .leaderboard-table {
    .fixed-column-leaderboard {
      width: 35% !important;
    }
  }
}
</style>
